import { appTheme } from "../theme/Theme";

export type TextSizeType = "xxs" | "xs" | "s" | "m" | "xms" | "xm" | "l" | "xl" | undefined;

export const getFontSize = (size: TextSizeType) => {
	switch (size) {
		case "xxs":
			return appTheme.fontSizes.FONT_SIZE_XXS;
		case "xs":
			return appTheme.fontSizes.FONT_SIZE_XS;
		case "s":
			return appTheme.fontSizes.FONT_SIZE_S;
		case "m":
			return appTheme.fontSizes.FONT_SIZE_M;
		case "xms":
			return appTheme.fontSizes.FONT_SIZE_XMS;
		case "xm":
			return appTheme.fontSizes.FONT_SIZE_XM;
		case "l":
			return appTheme.fontSizes.FONT_SIZE_L;
		case "xl":
			return appTheme.fontSizes.FONT_SIZE_XL;
		default:
			return appTheme.fontSizes.FONT_SIZE_M;
	}
};
